import script from "./ClassRooms.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassRooms.vue?vue&type=script&setup=true&lang=js"

import "./ClassRooms.vue?vue&type=style&index=0&id=6fcf891c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fcf891c"]])

export default __exports__